import React from "react";
import { CommonPage } from "@components/common";
import { useTranslation } from "react-i18next";

interface Props {
  pageWrapSize?: "medium" | "small" | "xsmall" | "xxsmall";
  children?: React.ReactNode;
}

export const CommonProductPage: React.FC<Props> = ({ children, pageWrapSize }) => {
  const { t } = useTranslation();
  return (
    <CommonPage pageWrapSize={pageWrapSize} documentTitle={t("landing:wizard:title")}>
      {children}
    </CommonPage>
  );
};
